import React, { useState } from "react";
import { useAudioSystem } from "../context/AudioContext";
import { OctagonX } from "lucide-react";

export default function StopAllButton() {
  const { stopAll, settings } = useAudioSystem();
  const [confirming, setConfirming] = useState(false);

  const handle = () => {
    if (settings.confirm_stop_all && !confirming) {
      setConfirming(true);
      setTimeout(() => setConfirming(false), 3000);
      return;
    }
    stopAll();
    setConfirming(false);
  };

  return (
    <button
      data-testid="stop-all-audio"
      onClick={handle}
      className={`w-full h-full min-h-[9rem] rounded-2xl font-display font-black tracking-tight flex flex-col items-center justify-center gap-2 active:scale-95 transition-transform duration-75 ${
        confirming ? "bg-white text-[#FF3B30] animate-emergency" : "bg-[#FF3B30] text-white"
      }`}
    >
      <OctagonX className="w-12 h-12" />
      <span className="text-2xl md:text-3xl">{confirming ? "TAP AGAIN TO CONFIRM" : "STOP ALL AUDIO"}</span>
    </button>
  );
}
